import { ArrowUpRight } from "lucide-react";
import { languages } from "@/data/trinityI18n";

const navTargets = ["#overview", "#line-card", "#trinity-model", "#solutions", "#inquiry"];

export function Header({ content, language, onLanguageChange }) {
  return (
    <header className="site-header" data-testid="main-header">
      <a className="brand-mark" href="#top" data-testid="header-brand-link" aria-label="Hi Power Electronics home">
        {content.brandLogo ? (
          <span className="brand-logo" data-testid="header-brand-logo">
            <img src={content.brandLogo} alt={content.brand || "Hi Power"} />
          </span>
        ) : (
          <span className="brand-symbol" data-testid="header-brand-symbol">H</span>
        )}
        <span data-testid="header-brand-name">{content.brand || "HI POWER ELECTRONICS"}</span>
      </a>

      <nav className="desktop-nav" data-testid="header-navigation" aria-label="Primary navigation">
        {content.nav.map((label, index) => (
          <a key={navTargets[index]} href={navTargets[index]} data-testid={`nav-link-${index + 1}`}>
            {label}
          </a>
        ))}
      </nav>

      <div className="header-actions" data-testid="header-actions">
        <div className="language-switcher" data-testid="language-switcher" aria-label="Language selector">
          {languages.map((lang) => (
            <button
              key={lang.code}
              type="button"
              className={language === lang.code ? "active" : ""}
              onClick={() => onLanguageChange(lang.code)}
              data-testid={`language-button-${lang.code}`}
              aria-pressed={language === lang.code}
            >
              {lang.short}
            </button>
          ))}
        </div>
        <a className="header-cta" href="#inquiry" data-testid="header-contact-link">
          {content.contact} <ArrowUpRight size={16} aria-hidden="true" />
        </a>
      </div>
    </header>
  );
}